import { render } from "./SelectRanking.vue?vue&type=template&id=68a44a4e&scoped=true"
import script from "./SelectRanking.vue?vue&type=script&lang=js"
export * from "./SelectRanking.vue?vue&type=script&lang=js"

import "./SelectRanking.vue?vue&type=style&index=0&id=68a44a4e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-68a44a4e"

export default script